"use client";
import { jsx } from 'react/jsx-runtime';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
import { aquaDark, black, brandBlueDark, greenDark, greyDark, magentaDark, orangeDark, pinkDark, purpleDark, redDark, yellowDark } from '../tokens/forimport/index.es.js';

const getAssistiveTextFromColorClass = (className) => {
  const classMapping = {
    "bad-news": "Error",
    brand: "Info",
    "good-news": "Success",
    warning: "Alert"
  };
  let text = classMapping[className];
  if (!text) {
    throw new Error("Provided class name does not map to a word.");
  }
  return text;
};
const withKeyboardTracker = (Component) => {
  const wrappedComponent = (props) => {
    const { additionalItems, ...rest } = props;
    const [currentFauxFocusIndex, setIndex] = useState(0);
    const [currentItemCount, setItemCount] = useState(0);
    const [onItemSelect, setOnItemSelect] = useState(() => noop);
    const handleKeyDown = useCallback(
      (event) => {
        let newIndex;
        switch (event.key) {
          case "ArrowUp":
            newIndex = Math.max(currentFauxFocusIndex - 1, 0);
            setIndex(newIndex);
            event.preventDefault();
            break;
          case "ArrowDown":
            const totalItemCount = currentItemCount + additionalItems;
            newIndex = Math.max(
              Math.min(currentFauxFocusIndex + 1, totalItemCount - 1),
              0
            );
            setIndex(newIndex);
            event.preventDefault();
            break;
          case "Enter":
            onItemSelect(currentFauxFocusIndex);
            event.preventDefault();
            break;
        }
      },
      [currentFauxFocusIndex, currentItemCount, onItemSelect, additionalItems]
    );
    const handleSetItemCount = useCallback(
      (count) => {
        setItemCount(count);
        if (count !== currentItemCount) {
          setIndex(0);
        }
      },
      [currentItemCount]
    );
    return /* @__PURE__ */ jsx(
      Component,
      {
        ...rest,
        currentFauxFocusIndex,
        handleKeyDown,
        setFauxIndex: setIndex,
        setItemCount: handleSetItemCount,
        setOnItemSelect
      }
    );
  };
  wrappedComponent.displayName = `withkeyboardTracker(${Component.displayName})`;
  wrappedComponent.propTypes = {
    additionalItems: PropTypes.number
  };
  wrappedComponent.defaultProps = {
    additionalItems: 0
  };
  return wrappedComponent;
};
const FILL_COLOR_MAP = {
  aqua: aquaDark,
  black,
  default: brandBlueDark,
  green: greenDark,
  grey: greyDark,
  magenta: magentaDark,
  orange: orangeDark,
  pink: pinkDark,
  purple: purpleDark,
  red: redDark,
  yellow: yellowDark
};

export { FILL_COLOR_MAP, getAssistiveTextFromColorClass, withKeyboardTracker };
